module.exports = __webpack_public_path__ + "static/overview-dark-e98b34625bfeefaf638e6c795b9ee053.png";